<template>
  <div class="m-rich-text-editor-flexbox">
    <div :class="countStatus" :data-testid="`${id}-text-count`">{{ internalPlainText.length }} / {{ maxLength }}</div>
    <div id="m-rich-text-editor" :class="borderStatus">
      <quill-editor
        ref="myEditor"
        v-model:content="internalHtmlContent"
        :read-only="readOnly"
        theme="snow"
        content-type="html"
        :toolbar="`#${id}-toolbar`"
        :data-testid="`${id}-quill-editor`"
        @focus="onFocus"
        @blur="onBlur"
      >
      <template #toolbar>
        <div :id="`${id}-toolbar`">
          <button class="ql-bold" :data-testid="`${id}-bold-button`"></button>
          <button class="ql-underline" :data-testid="`${id}-underline-button`"></button>
          <select class="ql-color"></select>
          <button class="ql-link" :data-testid="`${id}-link-button`"></button>
        </div>
      </template>
      </quill-editor>
    </div>
  </div>
</template>

<script>
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import '@vueup/vue-quill/dist/vue-quill.bubble.css';

export default {
  name: 'm-rich-text-editor',
  components: {
    QuillEditor,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    htmlContent: {
      type: String,
      default: '',
    },
    plainText: {
      type: String,
      default: '',
    },
    maxLength: {
      type: String,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['getHtmlContent', 'getText'],
  data() {
    return {
      editor: null,
      internalPlainText: this.plainText,
      internalHtmlContent: this.htmlContent,
      focusStatus: 'blur',
      overStatus: 'normal',
      countStatus: 'm-rich-text-editor-count__normal',
      borderStatus: 'm-rich-text-editor__blur',
    };
  },
  watch: {
    htmlContent(newHtmlContent) {
      // propsの変更を検知
      this.internalHtmlContent = newHtmlContent;
    },
    internalHtmlContent(newValue) {
      console.log('watch internalHtmlContent');
      // プレインテキストを取得
      if (this.editor) {
        let newPlainText = this.editor.getText();
        newPlainText = newPlainText.slice(0, newPlainText.length - 1);
        if (newValue.length > 0 && newPlainText.length === 0) {
          // 通信で取得したケース。htmlContentからプレーンテキストを取得して反映
          newPlainText = newValue.replaceAll('</p><p>', '\n</p><p>').replace(/<.+?>/g, '');
        }
        if (newPlainText.length > this.maxLength) {
          this.overStatus = 'over';
          this.borderStatus = 'm-rich-text-editor__over';
        } else {
          this.overStatus = 'normal';
          this.borderStatus = 'm-rich-text-editor__' + this.focusStatus;
        }
        this.countStatus = 'm-rich-text-editor-count__' + this.overStatus;
        this.internalPlainText = newPlainText;
        // エディターの編集を検知
        this.$emit('getText', newPlainText);
        this.$emit('getHtmlContent', newValue);
        // ql-editorのdata-testidを更新する
        this.setEditorTestIds();
      }
    },
  },
  mounted() {
    this.editor = this.$refs.myEditor;
    this.addKeydownListener();
    // DOM がレンダリングされた後、ql-editor に data-testid を追加する
    this.$nextTick(() => {
      this.setEditorTestIds();
    });
  },
  methods: {
    // Quill エディタ要素に data-testid を割り当て
    setEditorTestIds() {
      const quill = this.$refs.myEditor?.getQuill();
      if (quill && quill.root) {
        const editorElement = quill.root;
        const isBlank = editorElement.classList.contains('ql-blank');
        const testId = isBlank
          ? `${this.id}-editor-blank`
          : `${this.id}-editor`;
        editorElement.setAttribute('data-testid', testId);
      }
    },
    onFocus: function () {
      this.focusStatus = 'focus';
      this.borderStatus =
        this.overStatus === 'over' ? 'm-rich-text-editor__over' : 'm-rich-text-editor__' + this.focusStatus;
      this.setEditorTestIds();
    },
    onBlur: function () {
      this.focusStatus = 'blur';
      this.borderStatus =
        this.overStatus === 'over' ? 'm-rich-text-editor__over' : 'm-rich-text-editor__' + this.focusStatus;
      this.setEditorTestIds();
    },
    // タブ文字を禁止にする
    addKeydownListener() {
      const quillEditor = this.$refs.myEditor;
      const quill = quillEditor.getQuill();
      if (quill) {
        const keyboard = quill.getModule('keyboard');
        if (keyboard) {
          keyboard.bindings[9] = [];
          keyboard.addBinding({
            key: 9,
            handler: function () {
              return false;
            },
          });
        }
      }
    },
  },
};
</script>
